import { __decorate } from "tslib";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { AuthGuard } from "./shared/guards/auth-guard/auth.guard";
import { BackgroundPreloadService } from "./shared/services/background-preload/background-preload.service";
import { ApplicationsRoutingConstants } from "./tabs/applications/applications-routing.constants";
import { MapRoutingConstants } from "./map/map-routing.constants";
import { ViewApplicationRoutingConstants } from "./application/view-application/view-application-routing.constants";
import { PropertiesRoutingConstants } from "./tabs/properties/properties-routing.constants";
import { DashboardRoutingConstants } from "./core/dashboard/dashboard-routing.constants";
import { AppRoutingConstants } from "./app-routing.constants";
import { ToolsRoutingConstants } from "./core/tools/shared/tool-routing.constants";
import { aflaModuleServiceProvider } from "./shared/services/afla-module-strategy/afla-module-strategy.service.provider";
import { CreateApplicationRoutingConstants } from "./application/create-application/create-application-routing.constants";
import { SettingRoutingConstants } from "./core/settings/setting-routing.constants";
import { OrganisationRoutingConstants } from "./core/organisations/organisation-settings-routing.constants";
import { MobileConfigComponent } from "./core/mobile-config/mobile-config.component";
import { ApplyAccessComponent } from "./core/organisations/apply-access/apply-access.component";
import { RefreshComponent } from "./tabs/applications/shared/refresh/refresh.component";
import { ArcgisItemsRoutingConstants } from "./tabs/arcgis-items/arcgis-items-routing.constants";
import { OrganisationConfigComponent } from "./core/organisation-config/organisation-config.component";
import { BaysRoutingConstants } from "./tabs/bays/bays-routing.constants";
import { GravesRoutingConstants } from "./tabs/graves/graves-routing.constants";
import { POIRoutingConstants } from "./tabs/poi/poi-routing.constants";
import { StreetsRoutingConstants } from "./tabs/streets/streets.routing.constants";
import { LogoutComponent } from "./shared/components/logout/logout.component";
import { UnsecureViewDocumentsComponent } from "./unsecure/unsecure-view-documents/unsecure-view-documents.component";
import { FeatureSearchRoutingConstants } from "./search/feature-search/feature-search-routing.constants";
import { ApplicationSearchRoutingConstants } from "./search/application-search/application-search-routing.constants";
import { MaintenanceModeComponent } from "./shared/components/maintenance-mode/maintenance-mode.component";
import { MaintenanceGuard } from "./shared/guards/maintenance-gaurd/maintenance.guard";
import { MaintenanceModeConfigComponent } from "./core/maintenance-mode-config/maintenance-mode-config.component";
const routes = [
    {
        path: "unsecure/captureComment/:requestId",
        loadComponent: () => import("./unsecure/unsecure-capture-comment/unsecure-capture-comment.component")
            .then(m => m.UnsecureCaptureCommentComponent),
        pathMatch: AppRoutingConstants.PATH_MATCH_FULL
    },
    {
        path: "unsecure/viewDocuments/:requestId",
        component: UnsecureViewDocumentsComponent,
        pathMatch: AppRoutingConstants.PATH_MATCH_FULL
    },
    {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.ORGANISATION_ROUTE_ID_PARAMETER, OrganisationRoutingConstants.ORGANISATION_SETTINGS_ROUTE),
        loadChildren: () => import("./core/organisations/organisation-settings.module").then(mod => mod.OrganisationSettingsModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    }, /* // TODO: Figure out how to do this lazy loading and still access the MapModule in StepModule without having to load it twice
    {
      path: MapRoutingConstants.ESRI_MAP_ROUTE,
      loadChildren: () => import("./map/map.module").then(mod => mod.MapModule),
      canActivate: [AuthGuard],
      data: {preload: true}
    },*/
    {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, MapRoutingConstants.ESRI_MAP_ROUTE),
        loadChildren: () => import("./map/map.module").then(mod => mod.MapModule),
        canActivate: [AuthGuard, MaintenanceGuard],
        data: { preload: true }
    }, {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, ApplicationsRoutingConstants.APPLICATIONS_ROUTE),
        loadChildren: () => import("./tabs/applications/applications.module").then(module => module.ApplicationsModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, SettingRoutingConstants.SETTINGS_ROUTE),
        loadChildren: () => import("./core/settings/settings.module").then(module => module.SettingsModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, CreateApplicationRoutingConstants.CREATE_APPLICATION_ROUTE),
        loadChildren: () => import("./application/create-application/create-application.module").then(module => module.CreateApplicationModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE),
        loadChildren: () => import("./application/view-application/view-application.module").then(module => module.ViewApplicationModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, PropertiesRoutingConstants.PROPERTIES_ROUTE),
        loadChildren: () => import("./tabs/properties/properties.module").then(module => module.PropertiesModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, BaysRoutingConstants.BAYS_ROUTE),
        loadChildren: () => import("./tabs/bays/bays.module").then(module => module.BaysModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, POIRoutingConstants.POI_ROUTE),
        loadChildren: () => import("./tabs/poi/poi.module").then(module => module.PoiModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, StreetsRoutingConstants.STREETS_ROUTE),
        loadChildren: () => import("./tabs/streets/streets.module").then(module => module.StreetsModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, GravesRoutingConstants.GRAVES_ROUTE),
        loadChildren: () => import("./tabs/graves/graves.module").then(module => module.GravesModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, ArcgisItemsRoutingConstants.ARCGIS_ITEMS_ROUTE),
        loadChildren: () => import("./tabs/arcgis-items/arcgis-items.module").then(module => module.ArcgisItemsModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    },
    {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, FeatureSearchRoutingConstants.FEATURE_SEARCH_ROUTE),
        loadChildren: () => import("./search/feature-search/feature-search.module").then(module => module.FeatureSearchModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    },
    {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, ApplicationSearchRoutingConstants.APPLICATION_SEARCH_ROUTE),
        loadChildren: () => import("./search/application-search/application-search.module").then(module => module.ApplicationSearchModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    },
    {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, ToolsRoutingConstants.REPORT_ROUTE),
        loadChildren: () => import("./core/tools/report/report.module").then(module => module.ReportModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, ToolsRoutingConstants.REPORT_SCHEDULE_ROUTE),
        loadChildren: () => import("./core/tools/report-scheduler/report-schedule.module").then(module => module.ReporScheduletModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants
            .createRouteToView(AppRoutingConstants.MODULE_ID_ROUTE_PARAMETER, ToolsRoutingConstants.UPGRADE_WORKFLOW_ROUTE),
        loadChildren: () => import("./core/tools/upgrade-workflow/upgrade-workflow.module").then(module => module.UpgradeWorkflowModule),
        canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants.ORGANISATION_CONFIG_ROUTE,
        component: OrganisationConfigComponent,
        canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants.MOBILE_CONFIG_ROUTE, component: MobileConfigComponent, canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants.MAINTENANCE_MODE_CONFIG_ROUTE, component: MaintenanceModeConfigComponent, canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants.ORGANISATION_APPLY_ACCESS_ROUTE, component: ApplyAccessComponent, canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants.LOGOUT_ROUTE, component: LogoutComponent
    }, {
        path: ApplicationsRoutingConstants.REFRESH_ROUTE, component: RefreshComponent, canActivate: [AuthGuard, MaintenanceGuard]
    }, {
        path: AppRoutingConstants.MAINTENANCE_PATH, component: MaintenanceModeComponent, pathMatch: AppRoutingConstants.PATH_MATCH_FULL
    }, {
        path: "", redirectTo: DashboardRoutingConstants.MODULES_ROUTE, pathMatch: AppRoutingConstants.PATH_MATCH_FULL
    }
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = __decorate([
    NgModule({
        declarations: [], imports: [RouterModule.forRoot(routes, {
                preloadingStrategy: BackgroundPreloadService, onSameUrlNavigation: "reload"
            }), CommonModule], exports: [RouterModule], providers: [aflaModuleServiceProvider]
    })
], AppRoutingModule);
export { AppRoutingModule };
